import Loader from "react-loader-spinner";
import { Fragment,  useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setDialog } from "../../../store/api/CommonFunctions";
// import { addNewEvent, deleteEvent, getCustomerEvents } from "../../store/api/CustomerApi";
import { addNewEvent, deleteEvent, getStaffEvents } from "../../store/api/CustomerApi";
import { CheckLg, DashCircleFill, List, PlusSquare, Search } from "react-bootstrap-icons";
import DatePicker from "react-datepicker2";
import "react-datepicker2/src/styles/style.css";
import { setUserPop } from "../../store/api/Users";
import ModalSelectUser from "../ModalSelectUser";
import BihamtaTable from "../../../Components/BihamtaTable";
//let totalPage = 0;
const StaffEvents = (props) => {


    const dateTo = useRef();
    const dateFrom = useRef();
    const currPage = useRef(1);
    const totalPage = useRef(0);
    const eventData = useRef({});
    const searchData = useRef({});
    const dispatch = useDispatch();
    const { staffID } = props;
    const [pending, setPending] = useState(false);
    const [selectedUser, selectUser] = useState(null);
    const [eventError, setEventError] = useState({});
    const [showAddEvent, setShowAddEvent] = useState(false);
    const { list, typeList } = useSelector(state => {
        return {
            list: state.customerDataReducer.customerEventList,
            typeList: state.customerDataReducer.eventTypeList
        }
    });
    const search = (reset) => {
        if (reset) {
            currPage.current = 1;
            totalPage.current = 0;
        }
        if (selectedUser && selectedUser.ID) {
            searchData.current.CreateById = selectedUser.ID;
        }
        if (dateFrom.current.input.value === "") {
            searchData.current.DateFrom = null;
        }
        if (dateTo.current.input.value === "") {
            searchData.current.DateTo = null;
        }
        searchData.current.Skip = currPage.current - 1;
        searchData.current.CustomerID = staffID;
        searchData.current.IsStaff = true;
        searchData.current.Take = 10;
        dispatch(getStaffEvents(searchData.current));
    }
    const addEvent = () => {
        let er = {};
        if (!eventData.current.Description || eventData.current.Description === '') {
            er.Description = 'N';
        }
        setEventError(er);
        if (er.EventTypeID || er.Description) {
            return;
        }
        setPending(true);
        eventData.current.CustomerID = staffID;
        eventData.current.IsStaff = true;
        const onSuccess = () => {
            setPending(false);
            let searchData = {};
            searchData.Skip = 0;
            searchData.CustomerID = staffID;
            searchData.IsStaff = true;
            searchData.Take = 10;
            eventData.current = {};
            setShowAddEvent(false);
        dispatch(getStaffEvents(searchData));
        }
    dispatch(addNewEvent(eventData.current, onSuccess));
    }
    const cancelEvent = () => {
        eventData.current = {};
        setEventError({});
        setShowAddEvent(false);
    }
    const showUserPOP = () => {
        dispatch(setUserPop({ show: true, selectOneUser: selectUser }));
    }
    const tableColes = [
        { colTitle: "تاریخ رویداد", colName: "PCreationDate", showInMobile: true },
        { colTitle: "شرح رویداد", colName: "Description", showInMobile: true, maxTextLength: 150, colType: "string", hasTooltip:true },
        { colTitle: "تاریخ پیگیری", colName: "pNextDate", showInMobile: false },
        { colTitle: "ثبت کننده", colName: "CreateByName", showInMobile: false },
        { colTitle: "جزئیات بیشتر", colName: "MoreDetails", showInMobile: false }

    ]
    const tableRowButtons = [
        {
            title: "حذف رویداد", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف رویداد',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteEvent(item.ID, search)
                }))
            }
        }

    ]
    return (
        <Fragment>
            <ModalSelectUser />
            {!showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px", paddingBottom: "15px", margin: "5px" }}>
                    <div className="row" >
                        <div className="col-md-2 form-group">
                            <label>از تاریخ</label>
                            <DatePicker ref={dateFrom} isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => { searchData.current.DateFrom = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تا تاریخ</label>
                            <DatePicker ref={dateTo} isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => { searchData.current.DateTo = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        
                        <div className="col-md-3 form-group">
                            <label style={{ display: "block" }}>شرح رویداد</label>
                            <input type="text" className="form-control" onChange={e => searchData.current.Description = e.target.value} />
                        </div>                        
                        <div className="col-md-3 form-group">
                            <label style={{ display: "block" }}>ثبت کننده</label>
                            <input type="text" className="form-control"readOnly value={selectedUser ? selectedUser.Name : ""} />
                            <Button className="btn-input-tiny" onClick={showUserPOP}><List size={18} /></Button>
                        </div>
                    </div>
                    <Button variant="secondary" className="group-Btn mt-1" onClick={() => search(true)}><Search />&nbsp;جستجوی رویداد</Button>
                </div>
            }
            {showAddEvent &&
                <div style={{ border: "1px solid #b1b1b1", borderRadius: "3px", padding: "5px" }}>
                    <div className="row">
                        <div className="col-md-2 form-group">
                            <label>تاریخ پیگیری</label>
                            <DatePicker name="AlarmDate" isGregorian={false} timePicker={false} className="form-control"
                                onChange={value => { eventData.current.NextDate = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-6 form-group">
                            <label>شرح رویداد</label><span style={{ color: "red", fontSize: "14px" }}>*</span>
                            <input className="form-control" onChange={e => eventData.current.Description = e.target.value} />
                            {eventError.Description && <small className="errors">شرح رویداد الزامی است</small>}
                        </div>

                    </div>
                    <Button variant="success" className="group-Btn mt-2" onClick={addEvent}>
                        {!pending && <Fragment><CheckLg />&nbsp;ثبت رویداد</Fragment>}
                        {pending && <Fragment> <Loader type="BallTriangle" color="white" height={15} width={15} style={{ display: "inline-block" }} />&nbsp; منتظر بمانید</Fragment>}
                    </Button>
                    <Button variant="danger" className="group-Btn mt-2" onClick={cancelEvent}><DashCircleFill size={16} />&nbsp;انصراف</Button>
                </div>
            }
            {!showAddEvent && <Button className="group-Btn-smalll" style={{ textAlign: "center" }} onClick={() => setShowAddEvent(true)}><PlusSquare size={18} /></Button>}
            <BihamtaTable columns={tableColes} rowButtons = {tableRowButtons} reducerName="customerDataReducer" objectName="staffEvents" hasPageing={true}/>

        </Fragment >
    )
}
export default StaffEvents;